﻿import FeatureInteractionHandler from '../../map/handlers/FeatureInteractionHandler';
import * as eventTypes from '../../map/utils/eventTypes';
import * as layerTypes from '../../map/utils/layerTypes';
import * as featureInteractionTypes from '../../map/utils/featureInteractionTypes';
export default class EditControl {
    constructor(resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, toolbarContainer) {
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.toolbarContainer = toolbarContainer;

        this.editMode = false;
        this.multiGeom = false;
        this.layerId = null;
        this.featureInteractionHandler = new FeatureInteractionHandler(this.mapControl);
        this.layerGeomType = null;

        this.saveCallback = null;
        this.cancelCallback = null;
        this.currentAction = null;
        this.isFromForm = false;
        this.containerId = 'xpmap-' + this.mapControl.mapId + '-' + this.classId;
        this.controlId = 'js-modal-feature-tools-' + this.mapControl.mapId + '-' + this.classId;
    }

    init() {
        $("#" + this.containerId).parent().append('<div id="' + this.controlId + '" class="js-modal-feature-tools" style="display: none;"></div>');

        if ($('body:not(.nav-function-top)').length > 0) {
            $('#' + this.controlId).css('right', $('.header-options').width() + 30);
        }

        $event.register(eventTypes.FEATURE_TOOLS_COPY_ENDED, this._getFeatureCopyEndedHandler(), this, this.classId);
    }

    _getFeatureCopyEndedHandler() {
        let handler = (eventName, event, sender) => {
            let feature = event.feature;
            if (feature != null) {
                feature = feature.clone();
            }
            this.editSuspended = false;
            this.hide();

            this.startEdit(this.layerId, this.currentAction, this.saveCallback, this.cancelCallback, [feature]);
        };

        return handler;
    }

    startInsert(layerId, _saveCallback, _cancelCallback, action) {
        $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
        this.mapControl.generalActionHandler.generalActionControls.legendControl.toggleSelection(layerId, true);
        this.currentAction = action;
        this.saveCallback = _saveCallback;
        this.cancelCallback = _cancelCallback;

        if (this.editSuspended == true) {

            this.show();
            this.oldFeatures = [];
            var _features = this.featureInteractionHandler.editSource.getFeatures();
            if (_features != null && _features.length > 0) {
                for (var i = 0; i < _features.length; i++) {
                    let oldFeature = _features[i].clone();
                    oldFeature.layerId = _features[i].layerId;
                    this.oldFeatures.push(oldFeature);
                }
            }
            this.featureAdded = _features != null && _features.length > 0;

            $('#feature-tool-edit')[0].click();
            $event.notify(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, { visible: true }, this, this.classId);
            this.featureInteractionHandler.centerFeatures();
            $(this.target).css({ "cursor": "crosshair" });
        }
        else {
            this.hide();
            this.clear();
            this.editMode = false;
            this.featureAdded = false;
            this.layerId = layerId;
            this.layerGeomType = this._getLayerGeomType(this.layerId);
            this.show();
            var features = [];
            this.featureInteractionHandler.init({
                editMode: false,
                layerId: this.layerId,
                features: features,
                insertCallback: this.insertCallback(),
                editCallback: this.editCallback(),
                snapOpts: {
                    pixelTolerance: 25,
                    edge: true,
                    vertex: true,
                    intersection: true
                },
                action: featureInteractionTypes.INSERT
            });

            $('#feature-tool-edit')[0].click();
            $event.notify(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, { visible: true }, this, this.classId);
            $(this.target).css({ "cursor": "crosshair" });

            this.oldFeatures = [];
        }

    }

    _getLayerGeomType(layerId, features) {
        let layerSettings = this.layerSettingsHandler.getLayerSettings(layerId);

        if (layerSettings.Entity) {
            return layerSettings.Entity.GeometryFieldType;
        } else if (layerSettings.Type == layerTypes.TEMPORARY_VECTOR) {
            if (features == null || features.length == 0) {
                return 'POINT';
            } else {
                let geomType = features[0].getGeometry().getType();

                if (geomType == 'Point') {
                    return 'POINT';
                } else if (geomType == 'LineString') {
                    return 'LINE';
                } else {
                    return 'POLYGON';
                }
            }
        }
    }

    stopInsert() {
        this.saveCallback = null;
        this.cancelCallback = null;

        this.featureInteractionHandler.clear();
        $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
        this.hide();
        $(this.target).css({ "cursor": "default" });
        this.mapControl.refreshLayer(this.layerId);

        this.editSuspended = false;
    }

    _handleExistingFeatures(features) {
        if (features == null) {
            return null;
        }

        let result = [];

        features.forEach(feat => {
            if (feat.wkt && feat.srid) {
                let feature = this.mapControl.layerHandler.projectionHandler.wktToGeometry(feat.wkt, this.mapControl.map.getView().getProjection().getCode(), 'EPSG:' + feat.srid)
                result.push(feature);
            } else {
                result.push(feat);
            }
        });

        return result;
    }

    startEdit(layerId, action, _saveCallback, _cancelCallback, existingFeatures) {
        existingFeatures = this._handleExistingFeatures(existingFeatures);
        $event.notify(eventTypes.USER_INTERACTION_STARTED, {}, this, this.classId);
        this.mapControl.generalActionHandler.generalActionControls.legendControl.toggleSelection(layerId, true);
        this.currentAction = action;
        this.saveCallback = _saveCallback;
        this.cancelCallback = _cancelCallback;

        if (this.featureInteractionHandler && this.featureInteractionHandler.editSource && this.featureInteractionHandler.editSource.getFeatures().length == 0) {
            this.editSuspended = false;
        }

        if (this.editSuspended == true) {
            this.layerId = layerId;
            this.layerGeomType = this._getLayerGeomType(this.layerId, existingFeatures);
            this.show();
            this.oldFeatures = [];
            var _features = this.featureInteractionHandler.editSource.getFeatures();
            if (_features != null && _features.length > 0) {
                for (var i = 0; i < _features.length; i++) {
                    let oldFeature = _features[i].clone();
                    oldFeature.layerId = _features[i].layerId;
                    this.oldFeatures.push(oldFeature);
                }
            }

            $('#feature-tool-edit')[0].click();
            $event.notify(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, { visible: true }, this, this.classId);
            this.featureInteractionHandler.centerFeatures();
            $(this.target).css({ "cursor": "crosshair" });
        }
        else {
            this.layerId = layerId;
            this.layerGeomType = this._getLayerGeomType(this.layerId, existingFeatures);
            var features = existingFeatures != null ? existingFeatures : this.mapControl.selectionHandler.getAllSelectedFeatureDetails(this.layerId);
            this.oldFeatures = features;

            this.hide();
            this.clear();
            this.layerId = layerId;
            this.layerGeomType = this._getLayerGeomType(this.layerId, existingFeatures);
            this.editMode = action != null && (action.SubType == 'ADD' || action.SubType == 'ADD_MULTI') ? false : true;
            this.show();

            this.oldFeatures = [];
            if (features != null && features.length > 0) {
                for (var i = 0; i < features.length; i++) {
                    let oldFeature = features[i].clone();
                    oldFeature.layerId = features[i].layerId;
                    this.oldFeatures.push(oldFeature);
                }
            }

            this.featureInteractionHandler.init({
                editMode: true,
                layerId: this.layerId,
                features: features,
                insertCallback: this.insertCallback(),
                editCallback: this.editCallback(),
                snapOpts: {
                    pixelTolerance: 25,
                    edge: true,
                    vertex: true,
                    intersection: true
                },
                action: action != null ? action : featureInteractionTypes.EDIT
            });

            switch (action) {
                case featureInteractionTypes.EDIT: $('#feature-tool-edit')[0].click();
                    break;
                case featureInteractionTypes.MOVE: $('#feature-tool-move')[0].click();
                    break;
                default: $('#feature-tool-edit')[0].click();
                    break;
            }

            $event.notify(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, { visible: true }, this, this.classId);
            $event.notify(eventTypes.FEATURE_TOOLS_EDIT_STARTED, { features: features, layerId: this.layerId }, this, this.classId);
            this.featureInteractionHandler.centerFeatures();
            $(this.target).css({ "cursor": "crosshair" });
        }

        this.editSuspended = false;
    }

    stopEdit() {
        this.saveCallback = null;
        this.cancelCallback = null;

        this.featureInteractionHandler.clear();
        $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
        this.hide();
        $(this.target).css({ "cursor": "default" });
        this.mapControl.refreshLayer(this.layerId);

        this.editSuspended = false;
    }

    show() {
        var content = '<ul class="map-toolbar-list">';

        content += '<li class="map-toolbar-item header-icon" id="feature-tool-save" title="' + this.getResourceByKey('Save') + '"><i class="fal fa-save"></i></li>';
        content += '<li class="map-toolbar-item header-icon" id="feature-tool-close" title="' + this.getResourceByKey('Close') + '"><i class="fal fa-times"></i></li>';

        this.multiGeom = this.layerHasMultipleGeom(this.featureInteractionHandler.getOptionLayer(this.layerId));


        content += `<li class="map-toolbar-item header-icon" id="feature-tool-edit"><i class="fal fa-pencil-paintbrush" title="` + this.getResourceByKey('Edit geometry') + `"></i></li>
                    <li id="edit-insert-options" style="display: none;">
                        <ul class="map-sub-toolbar-list">
                            <li style="display: none;" class="map-toolbar-item header-icon edit-specific edit-specific-option" id="feature-tool-edit-specific" title="` + this.getResourceByKey('EditCurrentFeatures') + `"><i class="fal fa-pencil"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon line-specific edit-specific-option" id="feature-tool-insert-polyline" title="` + this.getResourceByKey('InsertPolyLine') + `"><i class="ni ni-graph"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon line-specific edit-specific-option" id="feature-tool-insert-line" title="` + this.getResourceByKey('InsertLine') + `"><i class="fal fa-slash" style="rotate: 90deg; font-size: 0.7rem; font-weight: 600; margin-left: 0.25rem;"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon polygon-specific edit-specific-option" id="feature-tool-insert-polygon" title="` + this.getResourceByKey('InsertPolygon') + `"><i class="fal fa-draw-polygon"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon polygon-specific edit-specific-option" id="feature-tool-insert-square" title="` + this.getResourceByKey('InsertSquare') + `"><i class="fal fa-draw-square"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon polygon-specific edit-specific-option" id="feature-tool-insert-circle" title="` + this.getResourceByKey('InsertCircle') + `"><i class="fal fa-draw-circle"></i></li>
                        </ul>
                    </li>`;
        content += '<li class="map-toolbar-item header-icon" id="feature-tool-move"><i class="fal fa-arrows-alt" title="' + this.getResourceByKey('Move geometry') + '"></i></li>';
        content += '<li class="map-toolbar-item header-icon" id="feature-tool-scale" style="display:none;"><i class="fal fa-crop-alt" title="' + this.getResourceByKey('Scale') + '"></i></li>';
        content += '<li class="map-toolbar-item header-icon" id="feature-tool-rotate" style="display:none;"><i class="fal fa-sync-alt" title="' + this.getResourceByKey('Rotate') + '"></i></li>';
        content += '<li class="map-toolbar-item header-icon" id="feature-tool-make-hole" style="display:none;"><i class="fal fa-stop-circle" title="' + this.getResourceByKey('Cut Hole') + '"></i></li>';
        content += `<li id="make-hole-insert-options" style="display: none;">
                        <ul class="map-sub-toolbar-list">
                            <li style="display: none;" class="map-toolbar-item header-icon polygon-specific edit-specific-option" id="make-hole-insert-polygon" title="` + this.getResourceByKey('InsertPolygon') + `"><i class="fal fa-draw-polygon"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon polygon-specific edit-specific-option" id="make-hole-insert-square" title="` + this.getResourceByKey('InsertSquare') + `"><i class="fal fa-draw-square"></i></li>
                            <li style="display: none;" class="map-toolbar-item header-icon polygon-specific edit-specific-option" id="make-hole-insert-circle" title="` + this.getResourceByKey('InsertCircle') + `"><i class="fal fa-draw-circle"></i></li>
                        </ul>
                    </li>`;

        if (this.editMode) {
            content += '<li class="map-toolbar-item header-icon" id="feature-tool-reverse"><i class="fal fa-repeat" title="' + this.getResourceByKey('Reverse geometry') + '"></i></li>';
        }
        
        content += '<li class="map-toolbar-item header-icon" id="feature-tool-copy"><i class="fal fa-copy" title="' + this.getResourceByKey('CopyGeometry') + '"></i></li>';

        content += '</ul>';
        $('#' + this.controlId).addClass("map-toolbar")
        $('#' + this.controlId).append(content);

        if ((this.editMode || this.editSuspended) && this.layerGeomType == 'POLYGON') {
            $('#feature-tool-make-hole').show();
        }

        if ((this.editMode || this.editSuspended) && (this.layerGeomType == 'POLYGON' || this.layerGeomType == 'LINE')) {
            $('.edit-specific').show();
            $('#feature-tool-scale').show();
            $('#feature-tool-rotate').show();
        }

        if (this.layerGeomType == 'POLYGON') {
            $('.polygon-specific').show();
        } else if (this.layerGeomType == 'LINE') {
            $('.line-specific').show();
        }

        this.addEventHandlers();
        $('#' + this.controlId).show();

        this.keydownEvent = (evt) => {
            if (evt.keyCode == 27) {
                var handler = this.featureCloseHandler();
                handler(evt);
            } else if (evt.keyCode == 46) {
                let lastPixel = this.mapControl.selectionHandler.lastPointerPixel;

                if (lastPixel != null) {
                    let pointerCoord = this.mapControl.map.getCoordinateFromPixel(lastPixel);

                    if (this.featureInteractionHandler != null && this.featureInteractionHandler.editSource != null) {
                        let hitFeature = this.featureInteractionHandler.editSource.getClosestFeatureToCoordinate(pointerCoord);
                        if (!hitFeature) return;
                        let viewResolution = this.mapControl.map.getView().getResolution();
                        let tolerance = viewResolution * 8;
                        let geom = hitFeature.getGeometry();
                        let type = geom.getType();

                        if (type === 'LineString') {
                            const coords = geom.getCoordinates();
                            let minIndex = -1;
                            let minSq = Infinity;
                            coords.forEach((c, idx) => {
                                const d = this._sqDist(c, pointerCoord);
                                if (d < minSq) {
                                    minSq = d;
                                    minIndex = idx;
                                }
                            });

                            if (Math.sqrt(minSq) <= tolerance) {
                                coords.splice(minIndex, 1);
                                if (coords.length < 2) {
                                    vectorSource.removeFeature(hitFeature);
                                } else {
                                    geom.setCoordinates(coords);
                                }
                            }
                        } else if (type === 'Polygon') {
                            const rings = geom.getCoordinates();
                            let closest = { ringIndex: -1, vertexIndex: -1, distSq: Infinity };
                            rings.forEach((ring, rIdx) => {
                                ring.forEach((coord, cIdx) => {
                                    const d = this._sqDist(coord, pointerCoord);
                                    if (d < closest.distSq) {
                                        closest = { ringIndex: rIdx, vertexIndex: cIdx, distSq: d };
                                    }
                                });
                            });

                            if (Math.sqrt(closest.distSq) <= tolerance) {
                                const { ringIndex, vertexIndex } = closest;
                                const ring = rings[ringIndex];

                                if (vertexIndex > 0 && vertexIndex < ring.length - 1) {
                                    ring.splice(vertexIndex, 1);

                                    ring.pop();
                                    ring.push(ring[0]);

                                    const newRings = rings.filter((r, idx) =>
                                        idx === 0 || r.length >= 4
                                    );

                                    geom.setCoordinates(newRings);
                                }
                            }
                        }
                    }
                }
            }
        };
        document.addEventListener('keydown', this.keydownEvent);
    }

    _sqDist(a, b) {
        const dx = a[0] - b[0];
        const dy = a[1] - b[1];
        return dx * dx + dy * dy;
    }

    addEventHandlers() {
        $('#feature-tool-save').on('click', this.featureSaveHandler());
        $('#feature-tool-close').on('click', this.featureCloseHandler());
        $('#feature-tool-edit').on('click', this.featureEditHandler());
        $('#feature-tool-move').on('click', this.featureMoveHandler());
        $('#feature-tool-reverse').on('click', this.featureReverseHandler());
        $('#feature-tool-copy').on('click', this.featureCopyHandler());
        $('#feature-tool-make-hole').on('click', this.featureMakeHoleHandler());
        $('#feature-tool-edit-specific').on('click', this.featureEditCurrentHandler());
        $('#feature-tool-insert-line').on('click', this.featureInsertLineHandler());
        $('#feature-tool-insert-polyline').on('click', this.featureInsertPolyLineHandler());
        $('#feature-tool-insert-polygon').on('click', this.featureInsertPolygonHandler());
        $('#feature-tool-insert-square').on('click', this.featureInsertSquareHandler());
        $('#feature-tool-insert-circle').on('click', this.featureInsertCircleHandler());
        $('#make-hole-insert-polygon').on('click', this.featureMakeHoleWithPolygonHandler());
        $('#make-hole-insert-square').on('click', this.featureMakeHoleWithSquareHandler());
        $('#make-hole-insert-circle').on('click', this.featureMakeHoleWithCircleHandler());
        $('#feature-tool-scale').on('click', this.featureScaleHandler());
        $('#feature-tool-rotate').on('click', this.featureRotateHandler());
    }

    featureScaleHandler(){
        var handler = (evt) => {
            if (!$('#feature-tool-scale').hasClass('active')) {
                if (this.layerGeomType == 'POLYGON') {
                    $('#feature-tool-make-hole').show();
                }

                $('#feature-tool-edit').show();
                this._clearSelection();
                this.setButtonActivated('#feature-tool-scale');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.SCALE);
            }
        };

        return handler;
    }

    featureRotateHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-rotate').hasClass('active')) {
                if (this.layerGeomType == 'POLYGON') {
                    $('#feature-tool-make-hole').show();
                }

                $('#feature-tool-edit').show();
                this._clearSelection();
                this.setButtonActivated('#feature-tool-rotate');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.ROTATE);
            }
        };

        return handler;
    }

    featureEditCurrentHandler() {
        var handler = (evt) => {
            this._clearSelection();
            this.setButtonActivated('#feature-tool-edit-specific');
            this.featureInteractionHandler.startInteraction(featureInteractionTypes.EDIT);
            $(this.target).css({ "cursor": "crosshair" });
            $('#edit-insert-options').show();
        };

        return handler;
    }

    featureInsertLineHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-insert-line').hasClass('active')) {
                this._clearSelection();
                this.setButtonActivated('#feature-tool-insert-line');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.INSERT, 'line');
            }
            $(this.target).css({ "cursor": "crosshair" });
            $('#edit-insert-options').show();
            $('#feature-tool-edit-specific').hide();
        };

        return handler;
    }

    featureInsertPolyLineHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-insert-polyline').hasClass('active')) {
                this._clearSelection();
                this.setButtonActivated('#feature-tool-insert-polyline');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.INSERT, 'polyline');
            }
            $(this.target).css({ "cursor": "crosshair" });
            $('#edit-insert-options').show();
            $('#feature-tool-edit-specific').hide();
        };

        return handler;
    }

    featureInsertPolygonHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-insert-polygon').hasClass('active')) {
                this._clearSelection();
                this.setButtonActivated('#feature-tool-insert-polygon');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.INSERT, 'polygon');
            }
            $(this.target).css({ "cursor": "crosshair" });
            $('#edit-insert-options').show();
            $('#feature-tool-edit-specific').hide();
        };

        return handler;
    }

    featureInsertSquareHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-insert-square').hasClass('active')) {
                this._clearSelection();
                this.setButtonActivated('#feature-tool-insert-square');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.INSERT, 'square');
            }
            $(this.target).css({ "cursor": "crosshair" });
            $('#edit-insert-options').show();
            $('#feature-tool-edit-specific').hide();
        };

        return handler;
    }

    featureInsertCircleHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-insert-circle').hasClass('active')) {
                this._clearSelection();
                this.setButtonActivated('#feature-tool-insert-circle');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.INSERT, 'circle');
            }
            $(this.target).css({ "cursor": "crosshair" });
            $('#edit-insert-options').show();
            $('#feature-tool-edit-specific').hide();
        };

        return handler;
    }

    featureMakeHoleHandler(){
        var handler = (evt) => {
            if (!$('#feature-tool-make-hole').hasClass('active')) {
                this.setButtonActivated('#feature-tool-make-hole');
                $('#feature-tool-make-hole').hide();
                $('#feature-tool-edit').show();
                $('#make-hole-insert-options').show();
                $('#make-hole-insert-polygon')[0].click();
            }
            $(this.target).css({ "cursor": "crosshair" });
        };

        return handler;
    }

    featureMakeHoleWithPolygonHandler() {
        var handler = (evt) => {
            this._clearSelection();
            this.setButtonActivated('#make-hole-insert-polygon');
            this.featureInteractionHandler.startInteraction(featureInteractionTypes.MAKE_HOLE, 'polygon');
            $('#make-hole-insert-options').show();
        };

        return handler;
    }

    featureMakeHoleWithSquareHandler() {
        var handler = (evt) => {
            this._clearSelection();
            this.setButtonActivated('#make-hole-insert-square');
            this.featureInteractionHandler.startInteraction(featureInteractionTypes.MAKE_HOLE, 'square');
            $('#make-hole-insert-options').show();
        };

        return handler;
    }

    featureMakeHoleWithCircleHandler() {
        var handler = (evt) => {
            this._clearSelection();
            this.setButtonActivated('#make-hole-insert-circle');
            this.featureInteractionHandler.startInteraction(featureInteractionTypes.MAKE_HOLE, 'circle');
            $('#make-hole-insert-options').show();
        };

        return handler;
    }

    featureSaveHandler() {
        var handler = (evt) => {

            if (this.saveCallback == null) {

                var ok = this.handleInteractionResult(this.featureInteractionHandler.getInteractionResult());
                if (ok) {
                    this.featureInteractionHandler.clear();
                    $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
                    this.hide();
                    $(this.target).css({ "cursor": "default" });
                }


            }
            else {
                this.saveCallback(this.featureInteractionHandler.getInteractionResult());
                this.featureInteractionHandler.clearInteractions();
                this.hide();
                $(this.target).css({ "cursor": "default" });
                this.editSuspended = true;
            }

            this.saveCallback = null;
            this.cancelCallback = null;
            this.softClear();
        };

        return handler;
    }

    featureCloseHandler() {
        var handler = (evt) => {

            if (this.layerId == layerTypes.REDLINE || this.layerId == layerTypes.MEASUREMENTS) {
                this.featureInteractionHandler.revertEdit();
            }

            if (this.cancelCallback != null) {
                this.featureInteractionHandler.clearInteractions();
                $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
                this.hide();
                $(this.target).css({ "cursor": "default" });
                this.cancelCallback();

                this.featureInteractionHandler.editSource.clear();
                this.mapControl.refreshLayer(this.layerId);
                
                this.editSuspended = false;
            }
            else {
                this.featureInteractionHandler.clear();
                $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
                this.hide();
                $(this.target).css({ "cursor": "default" });
                this.mapControl.refreshLayer(this.layerId);
            }

            this.softClear();
            this.saveCallback = null;
            this.cancelCallback = null;
        };

        return handler;
    }

    featureEditHandler() {
        var handler = (evt) => {
            this._clearSelection();
            this.setButtonActivated('#feature-tool-edit');
            $('#feature-tool-edit').hide();
            $('#feature-tool-make-hole').show();
            $('#edit-insert-options').show();

            if (this.layerGeomType == 'POINT') {
                this.featureInteractionHandler.startInteraction(this.editMode || this.featureAdded ? featureInteractionTypes.EDIT : featureInteractionTypes.INSERT);
                $('#feature-tool-edit').show();
                $('#feature-tool-make-hole').hide();
                $('#edit-insert-options').hide();
            } else {
                if (this.editMode || this.featureAdded || (this.oldFeatures != null && this.oldFeatures.length > 0)) {
                    $('#feature-tool-edit-specific').show();
                    $('#feature-tool-edit-specific')[0].click();
                } else {
                    if (this.layerGeomType == 'LINE') {
                        $('#feature-tool-insert-polyline')[0].click();
                    } else if (this.layerGeomType == 'POLYGON') {
                        $('#feature-tool-insert-polygon')[0].click();
                    }
                }
            }

            if (this.layerGeomType == 'LINE') {
                $('#feature-tool-make-hole').hide();
            }

            $(this.target).css({ "cursor": "crosshair" });

        };

        return handler;
    }

    featureMoveHandler() {
        var handler = (evt) => {

            if (!$('#feature-tool-move').hasClass('active')) {
                if (this.layerGeomType == 'POLYGON') {
                    $('#feature-tool-make-hole').show();
                }

                $('#feature-tool-edit').show();
                this._clearSelection();
                this.setButtonActivated('#feature-tool-move');
                this.featureInteractionHandler.startInteraction(featureInteractionTypes.MOVE);
            }
            $(this.target).css({ "cursor": "move" });

        };

        return handler;
    }

    featureReverseHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-reverse').hasClass('active')) {
                if (this.layerGeomType == 'POLYGON') {
                    $('#feature-tool-make-hole').show();
                }

                $('#feature-tool-edit').show();
                this._clearSelection();
                this.setButtonActivated('#feature-tool-reverse');
                if (this.saveCallback == null) {
                    var ok = this.handleInteractionResult(this.featureInteractionHandler.reverseVertices());
                    if (ok) {
                        this.featureInteractionHandler.clear();
                        $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
                        this.hide();
                        $(this.target).css({ "cursor": "default" });
                    }
                }
                else {
                    this.saveCallback(this.featureInteractionHandler.reverseVertices());
                    this.featureInteractionHandler.clearInteractions();
                    this.hide();
                    $(this.target).css({ "cursor": "default" });
                    this.editSuspended = true;
                }

                this.saveCallback = null;
                this.cancelCallback = null;
            }
        };

        return handler;
    }

    _clearSelection() {
        this.mapControl.selectionHandler.isTooltipHidden = true;
        this.mapControl.selectionHandler.isActive = false;
        this.mapControl.selectionHandler.copyMode = false;
    }

    featureCopyHandler() {
        var handler = (evt) => {
            if (!$('#feature-tool-copy').hasClass('active')) {
                if (this.layerGeomType == 'POLYGON') {
                    $('#feature-tool-make-hole').show();
                }
                $('#feature-tool-edit').show();
                this.setButtonActivated('#feature-tool-copy');
                this.featureInteractionHandler.clearInteractions();
                $(this.target).css({ "cursor": "default" });
                this.editSuspended = true;
                $event.notify(eventTypes.FEATURE_TOOLS_COPY_STARTED, null, this, this.classId);
            }
        };

        return handler;
    }

    handleInteractionResult(result) {
        if (result != null) {
            if (this.currentAction != null && (this.currentAction.SubType == 'ADD' || this.currentAction.SubType == 'ADD_MULTI')) {
                window.featuresToBeProcessed = result;

                var _url = this.rootURL + 'EntityForm/EntityFormRuntime?context=modal&idForm=' + this.currentAction.IdFormTarget + '&fromActionType=' + this.currentAction.SubType;

                var layer = this.mapControl.layerSettingsHandler.getLayerSettings(result.layerId);
                if (layer.IdExtConn != null) {
                    _url += "&idExtConn=" + layer.IdExtConn;
                } 

                _url += '&idApp=' + xapp.currentApp;
                let modalTitle = this.currentAction.Title;
                let modalIcon = this.currentAction.Icon;
                let modalWidth = '75%';
                let modalHeight = '75%';
                if (this.currentAction.UiContent != null && this.currentAction.UiContent.trim() != '') {
                    let uiContent = JSON.parse(this.currentAction.UiContent);

                    if (uiContent.modalWidth != null && uiContent.modalWidth.trim() != '') {
                        modalWidth = uiContent.modalWidth;
                    }

                    if (uiContent.modalHeight != null && uiContent.modalHeight.trim() != '') {
                        modalHeight = uiContent.modalHeight;
                    }
                }

                showResponsiveModalWindow(_url, modalTitle, modalIcon, modalWidth, modalHeight, true);

                return true;
            } else {
                if (result.layerId == layerTypes.REDLINE || result.layerId == layerTypes.MEASUREMENTS) {
                    return true;
                }

                var response = this.editMode ? this.mapControl.featureHandler.updateFeature(result) : this.mapControl.featureHandler.addFeature(result, this.currentAction);
                if (response) {
                    this.mapControl.refreshLayer(this.layerId);
                }

                return response;
            }
        }
        return true;
    }

    setButtonActivated(selector) {
        $('#edit-insert-options').hide();
        $('#make-hole-insert-options').hide();
        $(selector).siblings('.active').removeClass('active').attr('enabled', '0');
        $(selector).removeClass('disabled');
        $(selector).addClass('active');
    }

    setButtonEnabled(selector) {
        $(selector).removeClass('disabled');
        $(selector).removeClass('active');
    }

    hide() {
        $('#' + this.controlId)[0].innerHTML = '';
        $('#' + this.controlId).hide();
        document.removeEventListener('keydown', this.keydownEvent);
        this.keydownEvent = null;
        $event.notify(eventTypes.FEATURE_TOOLS_VISIBILITY_CHANGED, { visible: false }, this, this.classId);
    }

    layerHasMultipleGeom(layer) {
        if (layer.Entity && layer.Entity.GeometryFieldType.toLowerCase().indexOf('multi') > -1) {
            return true;
        } else {
            return false;
        }
    }

    clear() {
        if (this.featureInteractionHandler.initiated) {
            this.featureInteractionHandler.clear();
            $event.notify(eventTypes.FEATURE_TOOLS_EDIT_ENDED, null, this, this.classId);
            this.mapControl.refreshLayer(this.layerId);
            this.softClear();
        }
    }

    softClear() {
        this.editMode = false;
        this.multiGeom = false;
        this.layerId = null;
        this.oldFeatures = null;
    }

    insertCallback() {
        var callback = (feature) => {
            this.handleInserted(feature);
        };

        return callback;
    }

    editCallback() {
        var callback = () => {

        };

        return callback;
    }

    handleInserted(feature) {
        if (this.layerGeomType == 'POLYGON') {
            $('#feature-tool-make-hole').show();
        }

        if (this.layerGeomType == 'POLYGON' || this.layerGeomType == 'LINE') {
            $('#feature-tool-scale').show();
            $('#feature-tool-rotate').show();
        }
        this.featureAdded = true;
    }

    convertRemToPixels(rem) {
        return rem * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }

    getResourceByKey(key) {
        return this.mapUIResources == null || this.mapUIResources[key] == null ? key : this.mapUIResources[key];
    }
}